// extracted by mini-css-extract-plugin
export default {"card":"styles__card--fwEUm","card-header":"styles__card-header--qBLrV","card-desktop-title":"styles__card-desktop-title--rZXm6","card-content":"styles__card-content--egNAP"};